import PropTypes from 'prop-types'

const TextCell = ({ title, text, badge = null }) => {
  return (
    <div className="text-cell">
      <div className="text-cell-title">
        <span>{title}</span>
        {badge}
      </div>
      {text && <span>{text}</span>}
    </div>
  )
}

TextCell.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  badge: PropTypes.node,
}

export default TextCell
